// src/components/TextEditor.tsx
import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Importing the default Quill theme

interface TextEditorProps {
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}

const TextEditor = ({ value, onChange, className }: TextEditorProps) => {
  return (
    <div className="editor-container">
      <ReactQuill
        className={className}
        value={value}
        onChange={onChange}
        theme="snow"
        modules={{
          toolbar: [
            [{ header: "1" }, { header: "2" }, { font: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["bold", "italic", "underline"],
            ["link"],
            [{ align: [] }],
            ["image"],
            ["blockquote"],
            [{ color: [] }, { background: [] }],
            ["clean"], // for clearing the editor
          ],
        }}
      />
    </div>
  );
};

export default TextEditor;
